import { Button } from '@chakra-ui/react';

const ButtonOutline = ({ onClick, color = 'var(--color-info70)', height, width, borderWidth, children, ...props }) => (
  <Button
    background="white"
    color={color}
    border={`1px solid ${color}`}
    borderWidth={borderWidth}
    height={height}
    width={width}
    _hover={{ background: 'white' }}
    onClick={onClick}
    minWidth="unset"
    {...props}
  >
    {children}
  </Button>
);

export default ButtonOutline;
